import { Block } from 'webiq.boilerplate'

export default class CheckoutContent extends Block {
	static title = 'checkout-content'

	init() {
		this.products = document.querySelectorAll('.checkout-product')
		this.total = document.querySelector('.checkout-total')
		this.productsArray = []

		this.products.forEach((el) => {
			const product = {
				item_id: el.getAttribute('data-product-ean'),
				item_group_id: el.getAttribute('data-product-id'),
				item_name: el.getAttribute('data-product-name'),
				item_brand: el.getAttribute('data-product-brand') ? el.getAttribute('data-product-brand') : "Verstappen",
				item_category: el.getAttribute('data-product-category'),
				item_variant: el.getAttribute('data-product-variant'),
				price: parseFloat(el.getAttribute('data-product-price')),
				price_user: parseFloat(el.getAttribute('data-product-price-user')),
				quantity: el.getAttribute('data-product-quantity'),
				google_business_vertical: "retail",
				id: el.getAttribute('data-product-ean'),
			}
			this.productsArray.push(product)
		})

		this.ViewCart(this.productsArray)
	}

	ViewCart(payload) {
		const eurValue = (parseFloat(this.total.getAttribute('data-total')) / parseFloat(this.total.getAttribute('data-exchange-rate'))).toFixed(2)

		if ('dataLayer' in window) {
			window.dataLayer.push({ ecommerce: null }) // Clear the previous ecommerce object.
			window.dataLayer.push({
				event: 'view_cart',
				ecommerce: {
					currency: "EUR",
					currency_user: this.total.getAttribute('data-currency') ? this.total.getAttribute('data-currency') : "EUR",
					value: parseFloat(eurValue),
					value_user: parseFloat(this.total.getAttribute('data-total')),
					items: payload,
				},
			})
		}
	}
}
